import { Injectable, NgModule } from "@angular/core";
import { ActivatedRouteSnapshot, RouterModule, RouterStateSnapshot, Routes } from "@angular/router";
import { Observable } from "rxjs";
import { LoginComponent } from "./components/login/login.component";
import { TerminalComponent } from "./components/terminals/terminal/terminal.component";
import { TerminalsDefaultComponent } from "./components/terminals/terminals-default/terminals-default.component";
import { TerminalsComponent } from "./components/terminals/terminals.component";
import { AuthGuard } from "./services/auth-guard.service";
import { CanDeactivateTerminalGuard } from "./services/can-deactivate-terminal.guard";
import { TerminalsService } from "./services/terminals.service";

@Injectable()
export class TerminalResolver  {
  constructor(private backend: TerminalsService) { }

  resolve(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): Observable<any> | Promise<any> | any {
    return this.backend.getTerminalById(route.params.id, route.params.type);
  }
}

export const routes: Routes = [
  //{ path: '', component: LoginComponent, pathMatch: 'full' },
  { path: '', component: TerminalsDefaultComponent, pathMatch: 'full' },
  { path: 'login', component: LoginComponent, pathMatch: 'full' },
  { path: 'terminals', component: TerminalsDefaultComponent, canActivate: [AuthGuard] },
  {
    path: 'terminals/:type/:id',
    component: TerminalsComponent,
    canActivate: [AuthGuard],
    resolve: {
      terminal: TerminalResolver
    },
    children: [
      {
        path: '', pathMatch: 'full', component: TerminalComponent, canActivate: [AuthGuard], canDeactivate: [CanDeactivateTerminalGuard]
      }
    ]
  },
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule],
  providers: [TerminalResolver]
})
export class AppRoutingModule { }
